import { useEffect, useState } from 'react';

import UncontrolledTabs from './UncontrolledTabs';
import { getTabsCount } from '../helpers/count';

const MODE_UNCONTROLLED = 1;

const defaultProps = {
  defaultFocus: false,
  focusTabOnClick: true,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: 0,
  environment: null,
  disableUpDownKeys: false
};

const Tabs = (props) => {
  const { children, defaultFocus, defaultIndex, focusTabOnClick, onSelect } =
    props;
  const [focus, setFocus] = useState(defaultFocus);
  const [mode] = useState(MODE_UNCONTROLLED);
  const [selectedIndex, setSelectedIndex] = useState(
    mode === MODE_UNCONTROLLED ? defaultIndex : null
  );

  useEffect(() => {
    setFocus(false);
  }, []);

  const tabsCount = getTabsCount(children);
  useEffect(() => {
    if (mode === MODE_UNCONTROLLED) {
      if (selectedIndex != null) {
        const maxTabIndex = Math.max(0, tabsCount - 1);
        setSelectedIndex(Math.min(selectedIndex, maxTabIndex));
      }
    }
  }, [tabsCount]);

  const handleSelected = (index, last, event) => {
    if (typeof onSelect === 'function') {
      if (onSelect(index, last, event) === false) return;
    }

    if (focusTabOnClick) {
      setFocus(true);
    }

    if (mode === MODE_UNCONTROLLED) {
      setSelectedIndex(index);
    }
  };

  let subProps = { ...props };

  subProps.focus = focus;
  subProps.onSelect = handleSelected;

  if (selectedIndex != null) {
    subProps.selectedIndex = selectedIndex;
  }

  delete subProps.defaultFocus;
  delete subProps.defaultIndex;
  delete subProps.focusTabOnClick;

  return <UncontrolledTabs {...subProps}>{children}</UncontrolledTabs>;
};

Tabs.defaultProps = defaultProps;
Tabs.tabsRole = 'Tabs';
export default Tabs;
